import React, { useContext } from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { Props as IconProps } from '@wix/da-ds/pkg/Icons/IconWrap';
import { isImageDeviation } from '../../DeviationViews/_helpers';
import Dumbo from '../../DeviationViews/Dumbo';
import s from './SystemNotificationIcon.scss';

const ICON_DESKTOP_SIZE = 50;
const ICON_MOBILE_SIZE = 77;

export interface Props {
  iconComponent: React.ComponentType<IconProps>;
  backgroundDeviation?: PapiDeviation;
}

// C96
export const SystemNotificationIcon: React.FC<Props> = ({
  iconComponent: IconComponent,
  backgroundDeviation,
}) => {
  const isMobile = useContext(MobileContext);
  const iconSize = isMobile ? ICON_MOBILE_SIZE : ICON_DESKTOP_SIZE;
  const hasBackground = backgroundDeviation && isImageDeviation(backgroundDeviation);

  return (
    <div className={classnames(s['root'], !hasBackground && s['empty-background'])}>
      {hasBackground && backgroundDeviation && (
        <>
          <Dumbo
            className={s['thumb']}
            deviation={backgroundDeviation}
            width={iconSize}
            height={iconSize}
          />
          <div className={s['overlay']} />
        </>
      )}
      <IconComponent className={s['icon']} customSizable />
    </div>
  );
};
SystemNotificationIcon.displayName = 'SystemNotificationIcon';

export default SystemNotificationIcon;
